import { upload, UploadResponseModel } from "@/core/requests/book-creator";
import { ArrowUpTrayIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useState, FC, useRef, useEffect } from "react";
import IconButton from "./icon-button";
import { toastError } from "@/core/utils/notification";

enum UploadStates {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    WAITING = "WAITING"
}

interface FileUploadedItem {
    name: string,
    progress: number,
    status: UploadStates,
    file: File
}

const UploadFile: FC<{
    onSuccess: (data: UploadResponseModel) => void,
    directory_id?: string,
}> = ({ onSuccess, directory_id }) => {
    const [over, setOver] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [file_items, setFileItems] = useState<Array<FileUploadedItem>>([]);
    const currentUploadIndex = useRef(0);
    const pending = useRef(false);
    const fetchUpload = async () => {
        const file_item = file_items?.[currentUploadIndex.current];
        if (!file_item) {
            pending.current = false;
            return;
        }
        setUploading(true);
        handleUploadStatus(currentUploadIndex.current, UploadStates.PENDING)
        const res = await upload(file_item.file, (progress: number) => {
            // console.log("上传进度", progress)
            setProgress((progress * 100) >> 0);
        },directory_id);
        setUploading(false);
        if (res?.success) {
            const data = res.data;
            handleUploadStatus(currentUploadIndex.current, UploadStates.SUCCESS)
            onSuccess?.(data)
        } else {
            handleUploadStatus(currentUploadIndex.current, UploadStates.FAILED)
        }
        currentUploadIndex.current += 1;
        fetchUpload();
        return res;
    }

    const handleUploadStatus = (index: number, status: UploadStates) => {
        console.log("当前", index, status)

        setFileItems((pre) => {
            if (!pre?.[index]?.status) return [...pre];
            pre[index].status = status;
            return [...pre]
        });
    }

    useEffect(() => {
        if (!pending.current) {
            console.log("开始上传")
            pending.current = true;
            fetchUpload();
        }
    }, [file_items]);


    const handleUploadFile = (files: FileList) => {
        if (!files.length) return;
        const len = files.length;
        for (let index = 0; index < len; index++) {
            const file = files[index];
            setFileItems((pre) => {
                return [...pre, {
                    name: file.name,
                    progress: 0,
                    status: UploadStates.WAITING,
                    file,
                }]
            })
        }
    }


    const handleRemoveItem = (index: number) => {
        setFileItems((pre) => {
            return pre.filter((_, i) => index !== i);
        });
    }

    return <div>
        <div
            onDragOver={(event) => {
                event.preventDefault();
                if (!over) {
                    setOver(true);
                }
                console.log("悬空")
            }}
            onDragLeave={(event) => {
                event.preventDefault();
                if (over) {
                    setOver(false);
                }
                console.log("离开")
            }}
            onDrop={(event) => {
                event.preventDefault();
                if (over) {
                    setOver(false);
                }
                handleUploadFile(event.dataTransfer.files);
                // console.log(event.dataTransfer.files)
            }} className={`${over ? "border-primary" : ""} relative transition-all duration-300 hover:border-primary cursor-pointer rounded-md border-dashed border-border border-2 bg-white px-16 py-8 min-w-96 flex justify-center items-center flex-col`}>
            <ArrowUpTrayIcon className="text-info size-16" />
            {!uploading && <div className="text-center p-4 text-info text-sm/10">
                拖拽文件到区域内<span className="text-error">文件名内不允许包含空格和特殊字符</span>
            </div>}
            {uploading && <div className="text-center p-4 text-info">
                已上传{progress}%
            </div>}
            <input
                type="file"
                className="w-full h-full absolute opacity-0 cursor-pointer"
                multiple
                // accept=
                onChange={(e) => {
                    const files = e.target.files;
                    if (files) {
                        handleUploadFile(files);
                    }
                }}
            />
        </div>
        <div className="w-full max-h-64 overflow-scroll">
            <ul className="w-full py-2">
                {
                    file_items.map((item, index) => {
                        return <li className="list-none flex w-full justify-between border-b border-info p-2 items-center" key={index}>
                            <span className="max-w-48 line-clamp-1">{item.name}</span>
                            <div className="flex items-center">
                                {
                                    item.status === UploadStates.WAITING && <span className="px-2 text-sm">
                                        待上传
                                    </span>
                                }
                                {
                                    item.status === UploadStates.PENDING && <span className="px-2 text-sm">
                                        {
                                            `已上传 ${progress}% 请勿关闭`
                                        }
                                    </span>
                                }
                                {
                                    item.status === UploadStates.SUCCESS && <span className="px-2 text-sm text-success">
                                        上传成功
                                    </span>
                                }
                                {
                                    item.status === UploadStates.FAILED && <span className="px-2 text-sm text-error">
                                        上传失败
                                    </span>
                                }
                                <IconButton size={4} onClick={() => {
                                    handleRemoveItem(index);
                                }}>
                                    <XCircleIcon />
                                </IconButton>
                            </div>
                        </li>
                    })
                }
            </ul>
        </div>
    </div>
}

export default UploadFile;